import { render, staticRenderFns } from "./giftCard.vue?vue&type=template&id=42d15cef&scoped=true"
import script from "./giftCard.vue?vue&type=script&lang=js"
export * from "./giftCard.vue?vue&type=script&lang=js"
import style0 from "./giftCard.vue?vue&type=style&index=0&id=42d15cef&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_9104b087796de0a589f26e8ae34b49bc/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42d15cef",
  null
  
)

export default component.exports